import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconPhone from '@/components/icons/mobilePhone.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'

export default {
    name: "ServiceEmailAndPhone",
    components: {
        IconArrowBack,
        IconBase,
        IconForwardBack,
        IconPhone
    },
    data: () => ({
        first_name: "",
        email_address: "",
        phone_number: "",
        mobile_number: "",
        is_mobile: true,
        confirm_birth_day: "",
        confirm_birth_month: "",
        confirm_birth_year: "",
        dictionary: {
            custom: {
                email_address: {
                    required: () => 'Email address is required to proceed',
                    email: () => 'Invalid email'
                },
                phone_number: {
                    required: () => 'Phone number is required to proceed',
                    max: 'Cannot exceed more than 20 characters',
                    numeric: 'Phone number should only contains numerice characters',
                    regex: 'Please enter a valid Australian phone number'
                },
                mobile_number: {
                    required: () => 'Phone number is required to proceed',
                    max: 'Cannot exceed more than 11 characters',
                    numeric: 'Mobile number should only contains numerice characters',
                    regex: 'Please enter a valid Australian phone number'
                },
                confirm_birth_day: {
                    required: () => 'Birth day is required to proceed'
                },
                confirm_birth_month: {
                    required: () => 'Birth month is required to proceed'
                },
                confirm_birth_year: {
                    required: () => 'Birth year is required to proceed'
                }
            }
         }
    }),
    methods: {
        Next() {
            this.$validator.validateAll().then((result) => {
                if(result) {
                    this.$parent.ServiceInsuranceProcess.email_address = this.email_address;
                    if(this.is_mobile) {
                        this.$parent.ServiceInsuranceProcess.mobile_number = this.mobile_number;
                        this.$parent.ServiceInsuranceProcess.phone_number = "";
                    } else {
                        this.$parent.ServiceInsuranceProcess.phone_number = this.phone_number;
                        this.$parent.ServiceInsuranceProcess.mobile_number = "";
                    }
                    this.$parent.ServiceNextStep(8,"ServiceAdditionalBranches");
                }
            });
        },
        UpdateProcess(_isvalid) {
            if(_isvalid) {
                this.$parent.ServiceInsuranceProcess.email_address = this.email_address;
                if(this.is_mobile) {
                    this.$parent.ServiceInsuranceProcess.mobile_number = this.mobile_number;
                    this.$parent.ServiceInsuranceProcess.phone_number = "";
                } else {
                    this.$parent.ServiceInsuranceProcess.phone_number = this.phone_number;
                    this.$parent.ServiceInsuranceProcess.mobile_number = "";
                }
                this.$parent.ServiceNextStep(8,"ServiceAdditionalBranches");
            }
            
        },
        Next() {
            /* this can be improved and simplified*/
            let _false_counter = 0;
            this.$validator.validate('email_address', this.email_address).then((result) => { 
                if(!result) { _false_counter++; }
                if(this.is_mobile) {
                    this.$validator.validate('mobile_number', this.mobile_number).then((result) => { 
                        if(!result) { _false_counter++;}
                        if(_false_counter > 0) {
                            this.UpdateProcess(false);
                        } else {
                            this.UpdateProcess(true);
                        }
                    });
                } else {
                    this.$validator.validate('phone_number', this.phone_number).then((result) => { 
                        if(!result) { _false_counter++;}
                        if(_false_counter > 0) {
                            this.UpdateProcess(false);
                        } else {
                            this.UpdateProcess(true);
                        }
                    });
                } 
            });
            
            
        },
        CreateNumberRange(_start, _end) {
            let _data = [];
            for(var i = _start; i <= _end; i++) {
                if(i < 10) { _data.push("0" + i); } else { _data.push(i); }
            }
            return _data;
        },
        ValidateEmailAddress() {
            if(this.email_address !== "") {
                if(this.fields.email_address.valid) {
                    document.getElementById("email_address").classList.add("entry_valid")
                } else {
                    document.getElementById("email_address").classList.remove("entry_valid")
                }
            }
        },
        ValidateSessionData() {
            if(this.$parent.ServiceInsuranceProcess.email_address != null) {
                let _eip = this.$parent.ServiceInsuranceProcess;
                this.email_address = _eip.email_address;
                this.phone_number = _eip.phone_number;
                this.mobile_number = _eip.mobile_number;
                if(_eip.mobile_number != "") {
                    this.is_mobile = true;
                } else {
                    this.is_mobile = false;
                }
                this.$validator.validateAll(); /* this was added to add success state on fields and buttons */
            }
        },
        CheckSessionByEmail(){
            this.$parent.EducatorInsuranceProcess.email_address = this.email_address;

            //axios
            let CheckSessionByEmail_ = this.$parent.CheckSessionByEmail("EducatorInsuranceProcess");
            
            //check response of axios 
            CheckSessionByEmail_.then(response => {
                var count = response.data.customizations.results.length;
                this.db_session = response.data.customizations.results[0];
                
                //if session exist
                if(count > 0 ){
                    //check session if not expired
                    let isSessionNotExpired = this.$parent.CheckSessionExpiry("EducatorInsuranceProcess");
               
                    if(isSessionNotExpired == "false"){
                        this.dialog_check_sessions = true;
                        this.db_birthdate = this.$parent.db_session.birthdate;
                    }
                }
            })
            .catch(response => { 
                console.error("Check Session By Email", response);
            });
                    
        }
    },
    computed: {
        AllFieldsValid: function() {
            let _isvalid = false;
            let fld = this.fields;            
            if(fld.email_address) {
                if(fld.email_address.valid) {
                    if(this.is_mobile) {
                        if(fld.mobile_number.valid) {
                            _isvalid = true
                        } else {
                            _isvalid = false;
                        }
                    } else {
                        if(fld.phone_number.valid) {
                            _isvalid = true;
                        } else {
                            _isvalid = false;
                        }
                    }
                } else {
                    _isvalid = false;
                }
            }

            return _isvalid;
        }
    },
    mounted() {
        this.$validator.localize('en', this.dictionary) 
        this.first_name = this.$parent.ServiceInsuranceProcess.first_name;
        this.years = this.CreateNumberRange((new Date()).getFullYear() - 100,(new Date()).getFullYear());
        this.days_of_the_month = this.CreateNumberRange(1,31);
        this.$parent.CheckWindowPathName();
        this.ValidateSessionData();
        this.$parent.CurrentProcess = "ServiceInsuranceProcess";
    },
    watch : {
        dialog_check_sessions: function (newVal, oldVal) {
            const handler = e => {
                if (e.keyCode === 27) {
                    this.dialog_check_sessions = false
                    window.removeEventListener('keydown', handler)
                }
            }
            if(this.dialog_check_sessions == false){
            }else{
                window.addEventListener('keydown', handler)
            }
        },
    },
}